import { css } from '@emotion/react';
import { NTA_COLORS, NTA_FONT_AVERTA } from './constants';

export const ntaPageCss = css`
  --nta-font-family: ${NTA_FONT_AVERTA};

  &,
  & * {
    font-family: var(--nta-font-family) !important;
  }

  font-style: normal;
  font-weight: 400;
  -webkit-font-smoothing: auto;
  text-rendering: optimizeLegibility;
`;

export const ntaHeaderTitleCss = css`
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  line-height: 30px;
  letter-spacing: 0;
`;

export const ntaHeaderLabelCss = css`
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 18px;
  letter-spacing: 0;
`;

export const ntaIntroCss = css`
  font-size: 20px;
  font-weight: 900;
  font-style: normal;
  line-height: 24px;
  color: ${NTA_COLORS.textPrimary};
  overflow-wrap: break-word;
  word-wrap: break-word;
`;

export const ntaSectionTitleCss = css`
  font-size: 20px;
  font-weight: 700;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
`;

export const ntaBodyCss = css`
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0;
  color: ${NTA_COLORS.textSecondary};
`;

export const ntaBodyBoldCss = css`
  font-weight: 700;
  font-style: normal;
  letter-spacing: 0;
`;

export const ntaNoteCss = css`
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0;
  color: ${NTA_COLORS.noteText};
`;

export const ntaQuestionTitleCss = css`
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0;
  color: ${NTA_COLORS.questionText};
`;

export const ntaQuestionContentCss = css`
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  line-height: 24px;
  color: ${NTA_COLORS.questionText};
`;

export const ntaButtonCss = css`
  font-size: 14px;
  font-weight: 700;
  font-style: normal;
  line-height: 18px;
  letter-spacing: 0;
  text-transform: capitalize;
`;

export const ntaListMarkerCss = css`
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0;
`;
